<script setup lang="ts">
import BsNormalCard from '@/legacy/components/NormalCard.vue'
import { getVueAssetImagePath } from '@/lib/utils'

defineProps({
	info: {
		type: Object,
		require: true,
	},
	text: {
		type: Object,
	},
})
</script>

<template>
	<div>
		<BsNormalCard>
			<template #content>
				<div class="flex flex-row px-[16px] pb-[18px] pt-[20px]">
					<div class="pr-[8px]">
						<img
							:src="`${getVueAssetImagePath('coins.png')}`"
							:srcset="`
								${getVueAssetImagePath('coins.png')} 1x,
								${getVueAssetImagePath('coins@2x.png')} 2x,
								${getVueAssetImagePath('coins@3x.png')} 3x
							`"
						/>
					</div>
					<div>
						<div
							class="mb-[12px] pr-[8px] text-[16px] font-semibold leading-[24px] tracking-[0.15px] text-[#262626]"
						>
							{{ info?.remaining }}
						</div>
						<div
							class="mb-[4px] pr-[8px] text-[14px] leading-[20px] tracking-[0.25px] text-[#262626]"
						>
							{{ info?.total }}
						</div>
						<div
							class="mb-[4px] pr-[8px] text-[14px] leading-[20px] tracking-[0.25px] text-[#262626]"
						>
							{{ info?.convert }}{{ text?.contribution.unitTransform }}
						</div>
					</div>
					<div>
						<div
							class="mb-[16px] text-[14px] leading-[20px] tracking-[0.25px] text-[rgba(38,38,38,0.38)]"
						>
							{{ text?.contribution.total }}
						</div>
						<div
							class="mb-[4px] text-[14px] leading-[20px] tracking-[0.25px] text-[rgba(38,38,38,0.38)]"
						>
							{{ text?.contribution.totalEarn }}
						</div>
						<div
							class="mb-[4px] text-[14px] leading-[20px] tracking-[0.25px] text-[rgba(38,38,38,0.38)]"
						>
							{{ text?.contribution.convertCredit }}
						</div>
					</div>
				</div>
			</template>
		</BsNormalCard>
		<div
			class="mx-0 mb-[8px] mt-[24px] text-[16px] font-semibold leading-[24px] tracking-[0.15px] text-[rgba(38,38,38,0.87)]"
		>
			{{ text?.contribution.detail }}
		</div>
		<BsNormalCard>
			<template #content>
				<div class="px-[16px] pb-[24px] pt-[12px] lgOld:py-[8px]">
					<div class="flex content-start justify-between px-0 py-[6px]">
						<span
							class="flex items-start text-[14px] font-semibold leading-[24px] tracking-[0.1px] text-[rgba(38,38,38,0.38)]"
						>
							{{ text?.contribution.liked }}
						</span>
						<span
							class="flex items-start text-[14px] font-normal leading-[20px] tracking-[0.25px] text-[rgba(38,38,38,0.87)]"
						>
							{{ info?.liked }} {{ text?.contribution.unit }}
						</span>
					</div>
					<div class="flex content-start justify-between px-0 py-[6px]">
						<span
							class="flex items-start text-[14px] font-semibold leading-[24px] tracking-[0.1px] text-[rgba(38,38,38,0.38)]"
						>
							{{ text?.contribution.bookmarked }}
						</span>
						<span
							class="flex items-start text-[14px] font-normal leading-[20px] tracking-[0.25px] text-[rgba(38,38,38,0.87)]"
						>
							{{ info?.bookmarked }} {{ text?.contribution.unit }}
						</span>
					</div>
					<div class="flex content-start justify-between px-0 py-[6px]">
						<span
							class="flex items-start text-[14px] font-semibold leading-[24px] tracking-[0.1px] text-[rgba(38,38,38,0.38)]"
						>
							{{ text?.contribution.publish }}
						</span>
						<span
							class="flex items-start text-[14px] font-normal leading-[20px] tracking-[0.25px] text-[rgba(38,38,38,0.87)]"
						>
							{{ info?.publish }} {{ text?.contribution.unit }}
						</span>
					</div>
					<div class="flex content-start justify-between px-0 py-[6px]">
						<span
							class="flex items-start text-[14px] font-semibold leading-[24px] tracking-[0.1px] text-[rgba(38,38,38,0.38)]"
						>
							{{ text?.contribution.welcome }}
						</span>
						<span
							class="flex items-start text-[14px] font-normal leading-[20px] tracking-[0.25px] text-[rgba(38,38,38,0.87)]"
						>
							{{ info?.welcome }} {{ text?.contribution.unit }}
						</span>
					</div>
					<div class="flex content-start justify-between px-0 py-[6px]">
						<span
							class="flex items-start text-[14px] font-semibold leading-[24px] tracking-[0.1px] text-[rgba(38,38,38,0.38)]"
						>
							{{ text?.contribution.event }}
						</span>
						<span
							class="flex items-start text-[14px] font-normal leading-[20px] tracking-[0.25px] text-[rgba(38,38,38,0.87)]"
						>
							{{ info?.event }} {{ text?.contribution.unit }}
						</span>
					</div>
				</div>
			</template>
		</BsNormalCard>
	</div>
</template>
